import styled from 'styled-components';
import { device } from './responsives.js';

const font_themes = {
  fontfam: "Roboto", //not taking combined font
  headerfontsz: "22px",
  headerfontwght: "600",
  fontclr: "#84828F",
  parfontsz: "1.25em",
  parfontwght: "600",
  reviewfontsz: "1em"
}

export const LoadingCover = styled.div`
  position: fixed;
  padding-top: 100px;
  width: 100%;
  height: 100%;
  padding: 15% 35%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  z-index: 1;
`

export const LoadingInner = styled.div`
  display: "flex",
  justify-content: "center",
  align-items: "center",
  margin-top: 100px;
`

export const Container = styled.div`
  background-color: #ffffff;
  display: grid;
  width: 100vw;
  height: 100%;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 76px 1100px 76px;
  padding: 0px;
  background-color: #F4F8FB;
  @media ${device.maxlaptop}{
    grid-template-rows: 66px auto auto;
  }
  @media ${device.tablet}{
    grid-template-rows: 66px auto auto;
  }
  @media ${device.mobileL}{
    grid-template-columns: 1fr;
    grid-template-rows: 66px auto auto;
    margin: 0px;
  }
`

// allow overflow scrolling with a frozen header
export const Body = styled.div`
  display: grid;
  grid-column: 1 / span 5
  grid-template-rows: .4fr .2fr .2fr 2.2fr .2fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-row-gap: 10px;
  padding: 10px;
  height: auto;
  width: auto;
  @media ${device.maxLaptop}{
    margin: 0px 8px;
  }
  @media ${device.mobileL}{
    grid-template-rows: .3fr 2fr 1fr 1fr;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    margin: 0px;
  }
`

export const EntityContainer = styled.div`
  grid-row: 1;
  height: 80px;
  grid-column: 1 / span 2;
  background-color: #ffffff;
  margin: 0px 0px;
  padding: 0px;
  border-radius: 3px;
  position: absolute;
  width: 98vw;
  @media ${device.tablet}{
    height: 50px;
  }
`

export const SearchArea = styled.div`
  grid-row: 2;
  grid-column: 1 / span 3;
  padding: 0px;
  margin-top: 10px;
  display: inline-block;
  @media ${device.ipadPro}{
    margin-top: 20px;
  }
  @media ${device.tablet}{
    margin-top: 10px;
  }
`

export const BackButton = styled.button`
  display: block;
  position: absolute;
  bottom: 10px;
  border: none;
  background-color: transparent;
  visibility: ${props => (props.visible ? "visible" : "hidden")};
`

export const SVG = styled.div`
  height: 600px;
  width: 900px;
  @media ${device.reduction}{
    width: 600px;
  }
  @media ${device.ipadPro}{
  height: 400px;
  width: 550px;
  }
  @media ${device.tablet}{
    height: 400px;
    width: 550px;
  }
`

export const Graph = styled.div`
  grid-column: 1 / span 2;
  grid-row: 4;
  background-color: #ffffff;
  border-radius: 5px;
  position: relative;
  @media ${device.tablet}{
    grid-column: 1 /span 3;
  }
`

export const Reviews = styled.div`
  grid-column: 3 / span 4;
  grid-row: 3;
  grid-row-end: 5;
  padding: 10px;
  /* position: relative; */
  margin-left: 10px;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 20px 8px;
  border-radius: 5px;
  position: relative;
  font-family:${props=> font_themes.fontfam};
  @media ${device.tablet}{
    grid-row: 5;
    grid-column: 1 /span 3;
    margin-left: 0px;
  }
`

export const Summary = styled.div `
  padding: 10px;
  position: relative;
  height: auto;
  grid-column: 1 / span 2;
  grid-row: 3;
  margin-bottom: 0px;
  border-radius: 5px;
  background-color: #ffffff;
  font-family:${props=> font_themes.fontfam};
  @media ${device.tablet}{
    grid-column: 1 / span 3;
  }
`

export const SumHeader=styled.h1`
  display: block;
  margin: 10px 0px;
  font-size: ${props => font_themes.headerfontsz};
  font-weight: ${props => font_themes.headerfontwght};
`

export const SumText = styled.div`
  /* font-weight: ${props => font_themes.parfontwght}; */
  font-weight: 300;
  font-size: ${props => font_themes.parfontsz};
  margin-top: 10px;
`

// export const ChatDiv = styled.div`
//   margin-right: 8px;
//   margin-top: 8px;
//   height: 100%;
//   grid-column: 4;
//
//   @media ${device.mobileL}{
//     grid-row: 5;
//     height: 100px;
//     grid-column: 1 / span 4;
//   }
// `
